import { render, staticRenderFns } from "./PrimerHR.vue?vue&type=template&id=e0d006ee&scoped=true&"
import script from "./PrimerHR.vue?vue&type=script&lang=js&"
export * from "./PrimerHR.vue?vue&type=script&lang=js&"
import style0 from "./PrimerHR.vue?vue&type=style&index=0&id=e0d006ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d006ee",
  null
  
)

export default component.exports